import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Omini-Foods"
              description="Foodies Haven is your go-to place for discovering delicious recipes, staying updated with the latest food trends, and connecting with fellow food enthusiasts. Explore a variety of recipes, share your culinary creations, and join our interactive chat room to discuss all things food. "
              ghLink="https://duppala-chennakesava.github.io/omni_food/"
             
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Scaler Academy"
              description="we provide aspiring tech professionals with the tools, resources, and support they need to succeed designed to guide you step-by-step as you learn new skills, gain hands-on experience, and unlock the doors to a successful career in tech."
              ghLink="https://duppala-chennakesava.github.io/scalar/"
              demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Flat-Pack"
              description="HTML templates in one bundle isn't that awesome with a lot of features and great design brought to you by PixFort build which supports html, css, and code with instant view of website."
              ghLink="https://duppala-chennakesava.github.io/Flatpack/"
              demoLink=""              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Asha-Website"
              description="We are a team of talented designers making websites with Bootstrap.it provide the basic website for developing tools included in Bootstrap"
              ghLink="https://duppala-chennakesava.github.io/Asha_website/"
              demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Registration-Form"
              description="Its is a basic template for Registration form (or) it is designed using html and css."
              ghLink="https://duppala-chennakesava.github.io/Registration/"
              // demoLink="" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Soon..."
              description="Update Soon..."
              ghLink=""
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
